import React from 'react';
import Button from 'src/components/10-atoms/button/Button';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useI18n from 'src/modules/translations/hooks/useI18n';
const NoteTabNavButton = ({ direction, title, ...buttonProps }) => {
    const [{}] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    return (React.createElement(Button, { ...buttonProps, style: { alignSelf: 'center' }, variant: "outline", size: "sm", LeftIcon: props => React.createElement(FeatherIcon, { name: direction === 'previous' ? 'chevron-up' : 'chevron-down', ...props }) }, `${translate(direction === 'previous' ? 'Previous' : 'Next')}: ${title}`));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default NoteTabNavButton;
